export default {
  id: 'slack_promote_content',
  title: 'Promote content',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'CONTENT' ],
  description: 'Send a selected piece of content to your employees so they can easily share it across their network.',
  body: {
    blocks: [
      {
        text: {
          text: '[[INPUT_INTRODUCTION_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      },
      {
        text: {
          text: '*{{CONTENT_TITLE}}*',
          type: 'mrkdwn'
        },
        type: 'section'
      },
      {
        type: 'actions',
        elements: [
          {
            url: '{{CONTENT_LINKEDIN_SHARE_LINK}}',
            text: {
              text: 'LinkedIn',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
          {
            url: '{{CONTENT_FACEBOOK_SHARE_LINK}}',
            text: {
              text: 'Facebook',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
          {
            url: '{{CONTENT_WHATSAPP_SHARE_LINK}}',
            text: {
              text: 'Whatsapp',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
          {
            url: '{{CONTENT_TWITTER_SHARE_LINK}}',
            text: {
              text: 'Twitter',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          },
          {
            url: '{{CONTENT_MESSENGER_SHARE_LINK}}',
            text: {
              text: 'Messenger',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          }
        ]
      },
      {
        text: {
          text: 'Unsure what to send? How about:',
          type: 'mrkdwn'
        },
        type: 'section'
      },
      {
        text: {
          text: '[[INPUT_SHARE_TEXT]]\n{{CONTENT_SHARE_LINK}}',
          type: 'mrkdwn'
        },
        type: 'section'
      }
    ]
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following content with your network to win rewards! ...',
      defaultValue: 'Share the following content with your network to win rewards!',
      type: 'HTML'
    },
    INPUT_SHARE_TEXT: {
      label: 'Share Text',
      placeholder: 'Checkout the following page...',
      defaultValue: 'Checkout the following page.',
      type: 'HTML'
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/slack/promoteContent.js